import React, { Component } from 'react';
import API from 'API';
import Loader from 'components/common/Loader';
import TextHelpers from 'helpers/TextHelpers';

//-------------------------------------------------------------------------------------------------------------------

class FindProperty extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isBusy: false
        };
    }

    async componentDidMount() {
        const { bookingRequest } = this.props;
        API.call('book/init', bookingRequest);
    }

    async onSubmit() {
        const { onNextClicked, fns, bookingRequest } = this.props;
        const { isBusy } = this.state;
        if (isBusy) return;
        this.setState({ isBusy: true });
        try {
            const isAccountFound = await fns.tryLoadAccountInfo();
            if (isAccountFound) {
                await API.call('book/assert-ok-to-book', bookingRequest);
                onNextClicked();
            } else {
                window.location = 'https://www.wilkinschimneysweep.co.uk/out-of-territory';
            }
        } catch (error) {
            this.setState({ error });
        } finally {
            this.setState({ isBusy: false });
        }
    }

    render() {
        const { bookingRequest, onChange } = this.props;
        const { isBusy, error } = this.state;

        if (error) {
            return (<>

                <h2>Sorry, there's a problem...</h2>

                <p>{error}</p>

                <button
                    type="button"
                    className="btn me-auto"
                    onClick={() => this.setState({ error: null })}
                >
                    Go back
                </button>

            </>);
        }

        return (

            <form onSubmit={e => {
                e.preventDefault();
                this.onSubmit();
            }}>

                <h2>First, let's find your property.</h2>

                <p className="subtitle">
                    <span className="required-asterisk">*</span> Indicates required field
                </p>

                <div className="form-group required mb-3">
                    <label>What is your house number or name?</label>
                    <input
                        type="text"
                        className="form-control"
                        value={bookingRequest.houseNumber || ''}
                        onChange={e => onChange({ houseNumber: e.target.value })}
                        disabled={isBusy}
                    />
                </div>

                <div className="form-group required mb-3">
                    <label>What is your postcode?</label>
                    <input
                        type="text"
                        className="form-control"
                        value={bookingRequest.postcode || ''}
                        onChange={e => onChange({ postcode: e.target.value.toUpperCase().replace(/[^A-Z0-9 ]/, '') })}
                        disabled={isBusy}
                    />
                </div>

                <div className="nav-buttons">

                    <button
                        type="submit"
                        className="btn ms-auto"
                        disabled={isBusy}
                    >
                        {isBusy ?
                            <><Loader isInline />{' '}Please Wait...</> :
                            <>Next</>
                        }
                    </button>

                </div>

            </form>

        );
    }
    
}

export default FindProperty;